<template>
    <div class="bg-scroll min-h-screen w-full bg-gradient-to-r from-purple-300 to-blue-300 bg-cover">
        <div class="grid grid-cols-3 gap-4 justify-items-center">
            <div class="col-start-1 justify-self-start extrabold text-2xl lg:text-3xl mt-3 ml-5" >{{players}} Players</div>
            <div class="lg:col-span-1 col-span-3 lg:col-start-2 extrabold text-2xl lg:text-3xl md:text-2xl mt-3 ml-3 mr-3 lg:mt-5">{{scramble}}</div>
            <TimerBoard/>
        </div>
    </div>
</template>

<script>
import TimerBoard from '../components/TimerBoard.vue'
export default {
    components: {
        TimerBoard
    },
    data() {
        return{
            //socket: io('cuberivals.herokuapp.com'),
            socket: this.$store.state.socket,
            name: this.$store.state.name,
            roomId: this.$route.params.Room,
            scramble: "The Scramble will appear here, once your partner has joined",
            players: 0,
        }
    },
    mounted() {
        if(this.socket === null){
            this.$store.commit("changeId", {roomId: this.roomId})
            this.$router.push("/Pregame")
            return 
        }
        this.socket.emit("connected", {
            roomId: this.roomId,
            name: this.name
        })
        this.socket.on("scramble", (scramble) => {
            this.scramble = scramble
        })
        this.socket.on("newPlayerCount", (count) => {
            this.players = count
        })
        this.socket.on("newHost", () => {
            this.$store.commit("toggleHost")
        })
    },
    methods:{
    }
}
</script>

<style>

</style>